module.exports = __webpack_public_path__ + "img/contratacion.f1615789.svg";